import { HttpInterceptorFn } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../environments/environment';

export const addIdempotentKeyInterceptor: HttpInterceptorFn = (req, next) => {
   const handledMethodTypes = new Set(['POST', 'PATCH', 'PUT']);
   if (handledMethodTypes.has(req.method)) {
      let currentKey = localStorage.getItem(environment.idempotentStorageKeyName);
      if (!currentKey) {
         currentKey = uuidv4();
         localStorage.setItem(
            environment.idempotentStorageKeyName,
            JSON.stringify(currentKey)
         );
      }

      const modifiedRequest = req.clone({
         setHeaders: {
            IdempotencyKey: currentKey
         }
      });
      return next(modifiedRequest);
   }
   return next(req);
};
